<template>
  <div :id="id" :echartTitle="echartTitle">
    <div class="title1">提升机箕斗位置监控</div>
    <div class="table1">

    <table class="table table-striped table-bordered" align="center" valign="center">
<!--      <tr>-->
<!--        <td colspan="2" class="column">北车</td>-->
<!--        <td colspan="2" class="column">南车</td>-->
<!--      </tr>-->
      <tr>
        <td rowspan="2" class="column">北车</td>
        <td class="value2" colspan="2">箕斗1位置（米）</td>
        <td class="value2" colspan="2">箕斗2位置（米）</td>
      </tr>
      <tr>
        <td class="value1" colspan="2">{{ emPosition[0] }}</td>
        <td class="value1" colspan="2">{{ emPosition[1] }}</td>
      </tr>
      <tr>
        <td rowspan="2" class="column">南车</td>
        <td class="value2" colspan="2">箕斗1位置（米）</td>
        <td class="value2" colspan="2">箕斗2位置（米）</td>
      </tr>
      <tr>
        <td class="value1" colspan="2">{{ emPosition[2] }}</td>
        <td class="value1" colspan="2">{{ emPosition[3] }}</td>
      </tr>

    </table>

    </div>

  </div>
</template>

<script>

import EmCommonApi from "@/mixin/em/common/api";

export default {
  name: "dvProduct1",
  mixins: [EmCommonApi],
  props: {
    id: String,
    echartTitle: String,
  },
  data() {
    return {
      emPosition:[],

    }
  },
  watch:{

  },
  created() {
    this.getRemoteData();
  },
  mounted() {

    //window.addEventListener('resize', this.chart.resize, false);
    //这里可以屏蔽了，用watch生命周期监控year就可以触发了
    //this.getRemoteData();

    //定时轮巡查询
    this.fresh = setInterval(() => {
      this.getRemoteData();
      //window.addEventListener('resize', this.chart.resize, false)
    },  5000);

    this.dataRefreh();

  },
  destroyed() {
    //clearInterval(this.fresh);
    //window.removeEventListener('resize', this.chart.resize, false)
    this.clear();
  },
  methods: {
    // 定时刷新数据函数
    // dataRefreh() {
    //   // 计时器正在进行中，退出函数
    //   if (this.fresh != null) {
    //     return;
    //   }
    //   // 计时器为空，操作
    //   this.fresh = setInterval(() => {
    //     this.getRemoteData(); //加载数据函数
    //   }, 1000);
    //
    // },
    // 停止定时器
    clear() {
      clearInterval(this.fresh); //清除计时器
      this.fresh = null; //设置为null
    },

    getRemoteData() {
      const _api = this.$_emApiMixin_entityBaseApi("emSicEafmREocEmrec") + "/getListsByModuleCode?" +
          "code=1-3"
      // console.log("提取设备位置url：")
      // console.log(_api)
      this.$_emApiMixin_get(_api)
          .then((res) => {
            // console.log("提取设备位置：");
            // console.log(res);
            this.emPosition = [];
            for(let key in res){
              this.emPosition.push(parseFloat(res[key].newValue.value).toFixed(2));
            }
          })

      // console.log(this.emPosition)

    },

  }
}
</script>

<style scoped>
.title1{
  font-size: 1.2rem;
  font-family: '微软雅黑 Light';

  color: #fff;
  height:2.2rem;

}
.table{
  border-collapse: collapse;
  border-spacing: 0;
  background-color: transparent;
  display: table;
  width: 100%;
  max-width: 100%;

  margin:0 auto;
}
.table td{
  text-align:center;
  vertical-align:middle;
  padding: 0.1rem 0.2rem;
}
.table-bordered {
  border: 1px solid #fff;
}
*{
  margin: 0px;
  padding: 0px;
}
.column{
  font-size: 1.3rem;
  font-family: '微软雅黑';
  font-weight: bold;
  color: #fff;

  width:4rem;
  height:2.5rem;
  border:1px solid #aaa;
  background-color: rgba(101, 132, 226, 0.3);
}

.value1{
  font-size: 2.2rem;
  font-family: electronicFont;
  color: #fff;
  width:4rem;
  height:3.5rem;
  border:1px solid #aaa;
  background-color: rgba(153, 102, 204, 0.3);
}
.value2{
  font-size: 1.3rem;
  font-family: '微软雅黑';
  color: #fff;
  width:4rem;
  height:3.5rem;
  border:1px solid #aaa;
  background-color: rgba(102, 255, 153, 0.3);
}
/*液晶数字字体*/
@font-face {
  font-family: electronicFont;
  src: url("../../../../assets/font/DS-DIGIT.TTF");
}

</style>
